import classNames from 'classnames';
import TeamList, { TeamListProps } from '../../shared/TeamList';
import Typografed from '../../shared/Typografed';

export type TeamSectionProps = TeamListProps & {
    title: string;
};

type Props = React.HTMLAttributes<HTMLElement> & {
    teamSectionProps: TeamSectionProps;
};

export const SECTION_ID = 'team';

function TeamSection({ teamSectionProps, ...props }: Props) {
    const departments = teamSectionProps.departments;

    return (
        <section {...props} id={SECTION_ID} className={classNames('team-section', props.className)}>
            <div className="wrapper">
                {teamSectionProps.title && (
                    <h2 className="h4 team-section__title">
                        <Typografed>{teamSectionProps.title}</Typografed>
                    </h2>
                )}
                {departments && <TeamList departments={departments} />}
            </div>
        </section>
    );
}

export default TeamSection;
